import addInfoBarMessage from './addInfoBarMessage';
import updateSensitivityInfoBar from './updateSensitivityInfoBar';
import loadAttachmentPolicyInfoBars from '../orchestrators/loadAttachmentPolicyInfoBars';
import ComposeViewState from '../store/schema/ComposeViewState';
import { isFeatureEnabled } from 'owa-feature-flags';
import { action } from 'satcheljs/lib/legacy';

export default action('loadComposeInfoBars')(function loadComposeInfoBars(
    viewState: ComposeViewState
) {
    if (!isFeatureEnabled('cmp-upgradeCompose')) {
        // Add "quoted body will be loaded" infobar if quoted body is not loaded for smart response in full compose
        if (
            viewState.useSmartResponse &&
            !viewState.isInlineCompose &&
            !viewState.itemId &&
            !viewState.quotedBody
        ) {
            addInfoBarMessage(viewState, 'warningNoQuotedBody');
        }
    }
    loadAttachmentPolicyInfoBars(viewState);

    updateSensitivityInfoBar(viewState);
});
